import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ props: { position } }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    gap: 16px;

    ${position === 'center' &&
    css`
      width: 100%;
      height: 100%;
    `}
  `,
} satisfies Styles<{ position: 'inline' | 'center' }>;

export const useStyles = withStyles(styles);
